<div class="loader-overlay" *ngIf="isLoaderOn">
    <div class="loaderContainer">
        <kendo-loader type="infinite-spinner" size="large" themeColor="primary" class="primaryBlue">
        </kendo-loader>
    </div>
</div>